import {z} from '@hono/zod-openapi';

export const composeMessageFactSchema = z
  .object({
    key: z.string().min(1).max(128),
    label: z.string().min(1).max(128),
    value: z.string().min(1).max(2000),
  })
  .strict()
  .openapi('ComposeMessageFact');
